import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { links } from '../utils/constants';
import InfoPage from '../views/pages/enter/InfoPage';
import ModeDePaiementPage from '../views/pages/paiement/ModeDePaiementPage';
import PaiementPage from '../views/pages/paiement/PaiementPage';

const OwnRoute = () => {
    const routes = [
        {
            path: links.home,
            component: <InfoPage/>
        },
        {
            path: links.modepaiement,
            component: <ModeDePaiementPage/>
        },
        {
            path: links.paiement,
            component: <PaiementPage/>
        },
    ]
    return (
        <Routes>
            {
                routes.map((route, index) => (
                    <Route key={index} path={route.path} element={route.component} />
                ))
            }
        </Routes>
    );
};

export default OwnRoute;